import React from 'react';
import classNames from 'classnames';

export default function OfferIcon({ className = '' }) {
	return <span className={classNames('icon icon-offers', className)} />;
}
